import { useTranslation } from "react-i18next";
import "./StatusCheckbox.css";

/**
 * Caixa de marcação com etiqueta ao lado, alinhadas pelo meio.
 *
 * Não usa o `.form-check` nem o `.form-check-label` do tema de propósito. As duas classes
 * carregam um layout que alinha caixa e texto pelo topo — o Bootstrap faz o input flutuar à
 * esquerda e o tema ainda soma `top` no input e `margin-top` na etiqueta —, e sobrescrever
 * isso virava uma disputa de especificidade decidida pela ordem de carga das folhas.
 *
 * Do tema fica só o `.form-check-input`, que desenha a caixa; o alinhamento passa a ser uma
 * linha flex deste componente.
 *
 * A etiqueta é irmã do input, e não o envolve: com o input dentro do `<label htmlFor>`, o
 * clique na caixa borbulha para a etiqueta, que reativa o controle, e o `onClick` das telas
 * dispara duas vezes — o estado volta ao valor anterior e a caixa parece não funcionar.
 */
const StatusCheckBox = (props) => {
    const { t } = useTranslation();
    const { label, className, ...inputProps } = props;
    const checkboxId = props.id || props.name || 'statusCheckbox';

    return (
        <div className={`status-checkbox${className ? ` ${className}` : ""}`}>
            <input
                id={checkboxId}
                className="form-check-input"
                type="checkbox"
                {...inputProps}
            />
            <label htmlFor={checkboxId} className="status-checkbox__label">
                {label || t('active')}
            </label>
        </div>
    );
}

export default StatusCheckBox;
